import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import theme from "../styles/theme";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { clearSnackbarAction, snackbarSelector } from '../../adapters/redux'
import {
  faTimesCircle,
  faCheckCircle
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconContainer = styled.span`
  padding-right: .5rem;
`;
const IconButton = styled.button`
  background: none;
  border: none;
  color: white;
`;

export default function SuccessSnackbar() {
  const dispatch = useDispatch();

  const snackbar = useSelector(snackbarSelector);

  function handleClose() {
    dispatch(clearSnackbarAction());
  }

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      open={snackbar?.successSnackbarOpen}
      autoHideDuration={4000}
      onClose={handleClose}
      aria-describedby="client-snackbar"
    >
      <SnackbarContent style={{
        backgroundColor: theme.colors.success,
      }}
        message={
          <span id="client-snackbar">
            <IconContainer>
              <FontAwesomeIcon icon={faCheckCircle} />
            </IconContainer>
            {snackbar?.successSnackbarMessage}
          </span>
        }
        action={
          <IconButton onClick={handleClose}><FontAwesomeIcon icon={faTimesCircle} /></IconButton>
        }
      />
    </Snackbar>
  );
}